import React from 'react';
import { NestedEntry, SingleEntry, isNestedEntry } from '../../graphql-fragments/navigationMenu';
import { clsx } from '../../utils/utils';

import * as styles from './Menu.module.scss';
import MenuEntry from './MenuEntry';
import NestedMenuEntry from './NestedMenuEntry';

interface MenuProps {
  entries: Array<SingleEntry | NestedEntry>;
  areasOfExpertiseEntries: Array<SingleEntry>;
  headerWithOpaqueBackground?: boolean;
  className?: string;
}

const Menu = ({
  entries,
  areasOfExpertiseEntries,
  headerWithOpaqueBackground,
  className,
}: MenuProps): React.ReactElement => {
  return (
    <nav className={clsx(styles.menuDesktop, className)} aria-label="Navigation">
      <div className={styles.container}>
        {entries.map((entry, i: number) =>
          isNestedEntry(entry) ? (
            <NestedMenuEntry
              entry={entry}
              key={i}
              areasOfExpertiseEntries={areasOfExpertiseEntries}
              headerWithOpaqueBackground={headerWithOpaqueBackground}
            />
          ) : (
            <MenuEntry
              entry={entry}
              key={i}
              headerWithOpaqueBackground={headerWithOpaqueBackground}
            />
          ),
        )}
      </div>
    </nav>
  );
};

export default Menu;
